import timeFormAPI from '../../api/ui/timeFormAPI';
import { create } from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import changeNumApi from '../../api/ui/changeNumApi';

function useSchemaNicknameLog() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.log.perplay.nickname.table.head.no', // "로그 번호",
    'admin.log.perplay.nickname.table.head.tran.no', // "트랜잭션 번호",
    "유저 ID",
    'admin.log.perplay.nickname.table.head.nickname', // "유저 닉네임(이전 → 이후)",
    'admin.log.perplay.nickname.table.head.cost', // "변경 비용",
    'admin.log.perplay.nickname.table.head.type', // "변경 주체",
    'admin.log.perplay.nickname.table.head.create', // "변경 시각",
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const no = row?.logNo || 0;
    const tranNo = row?.transactionNo || 0;
    const email = row?.email || '';
    const accountNo = row?.accountNo || 0;
    const nickname = row?.nickname || '';
    const pre = row?.beforeNickname || '';
    const cost = changeNumApi.div18(row.cost);
    const type =
      row?.managerEmail || row?.managerNo
        ? row?.managerEmail || '운영자'
        : '사용자';
    const createAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: no, // 키는 반드시 있어야 한다.
      param1: no,
      param2: tranNo,
      param3 : accountNo,
      param4: `${pre} → ${nickname}`,
      param5: cost,
      param6: type,
      param7: createAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaNicknameLog;
